/**
 * Created by Patrick on 7/5/2019.
 */

import React, { Component } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import Row from '../components/Row'
import NoRecordsFound from '../components/NoRecordsFound'

class DevicesList extends Component {
  headers = [
    {
      key: "name",
      name: "Name",
      width: 2
    },
    {
      key: "os",
      name: "OS",
      width: 2
    },
    {
      key: "osVersion",
      name: "Version",
      width: 2
    },
    {
      key: "model",
      name: "Model",
      width: 2
    },
    {
      key: "deviceType",
      name: "Device Type",
      width: 2
    },
    {
      key: "tracking",
      name: "Tracking",
      sortable: false,
      width: 1
    },
    {
      key: "add",
      name: "Add",
      sortable: false,
      width: 1
    }
  ]


  renderTableHeaders = () => {
    const { onSort, sortBy, isSortAsc } = this.props;
    const arrow = isSortAsc ? <span className="glyphicon glyphicon-triangle-top" title="Ascending" /> : <span className="glyphicon glyphicon-triangle-bottom" title="Descending"/>

    return this.headers.map(({ key, name, width, sortable }) => {
        if (sortable === false) {
            return (
                <th key={key}>
                    <div className={`text-center table-header col-sm-${width}`}>{name}</div>
                </th>
            )
        }

        return (
            <th key={key}  onClick={() => onSort(key)}>
                <div className={`text-center table-header table-header-clickable col-sm-${width} flex-center`} >
                    {name} {sortBy === key && arrow }
                </div>
            </th>
        )
    })
  }

  renderTableRows = () => {
    const { devices, onAdd } = this.props;

    if (devices.length) {
      return devices.map(device => {
        const trackingIcon = device.trackingDevice ? <span className="glyphicon glyphicon-ok glyphicon-large grey" /> : <span className="glyphicon glyphicon-remove glyphicon-large faint-grey" />
        const addButton = (<a className="device-add"><span className="glyphicon glyphicon-plus add-button" /></a>)

        // Select what fields should be displayed in the row
        const selectedFields = {
          name: device.name,
          os: device.os,
          osVersion: device.osVersion,
          model: device.model,
          deviceType: device.deviceType,
          tracking: trackingIcon,
          add: addButton
        }
  
        return (
          <Row 
            key={device._id} 
            data={selectedFields}
            onClick={() => onAdd(device._id)}
          />
        );
      });
    }

    return <NoRecordsFound />
  }

  render() {
    const { isLoading } = this.props;

    return (
      <div className="test-instance-list">
        { isLoading ? <div className="flex-center"><LoadingSpinner /></div> : (
              <table className="table">
                <thead className="test-instance-details-head">
                  <tr>
                    { this.renderTableHeaders() }
                  </tr>
                </thead>
                <tbody>
                  { this.renderTableRows() }
                </tbody>
              </table>
        )}
      </div>
    ); // return
  } // render
} // DevicesList

export default DevicesList;
